// extracted by mini-css-extract-plugin
module.exports = {"employment-based":"EmploymentBased_employment-based__8fp6A","employment-based__hero":"EmploymentBased_employment-based__hero__8SskE"};